import { Injectable } from '@angular/core';
import { PreloadingStrategy, Route } from '@angular/router';
import { Observable, of } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SelectivePreloadStrategy implements PreloadingStrategy {
  // Rutas críticas que deben precargarse en background tras el login
  // Las demás se cargarán únicamente bajo demanda (lazy loading)
  private readonly PRELOAD_WHITELIST = ['menu', 'home', 'perfil', 'citas', 'rutinas'];

  preload(route: Route, load: () => Observable<any>): Observable<any> {
    const routePath = route.path || '';
    const shouldPreload = route.data?.preload === true ||
                          this.PRELOAD_WHITELIST.includes(routePath);

    if (shouldPreload) {
      return load();
    }

    return of(null);
  }
}
